import React from 'react';
import KpiTile from '../../components/molecules/KpiTile';
import TruncatedNote from './TruncatedNote';
import { TRANSLATION_KEY } from '../constants';
import { statsViewShape } from '../propShapes';
import { buildVerdictDelta, formatVerdictValue } from '../verdictFormat';
import css from './StatsTiles.css';

const StatsTiles = ({ view }) => (
    <div>
        <div className={css.tiles}>
            {view.items.map((item, index) => (
                <KpiTile
                    key={`${item.label}-${index}`}
                    compact
                    label={item.label}
                    value={formatVerdictValue(item.value, item.display_format)}
                    valueTooltip={
                        typeof item.value === 'number'
                            ? formatVerdictValue(item.value, item.display_format, { compact: false })
                            : null
                    }
                    delta={buildVerdictDelta(item.delta, item.tone)}
                />
            ))}
        </div>
        <TruncatedNote count={view.truncated_count} translationId={`${TRANSLATION_KEY}.CARD.MORE_METRICS`} />
    </div>
);

StatsTiles.propTypes = {
    view: statsViewShape.isRequired,
};

export default StatsTiles;
